import Routers from './routes'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import tema from './theme';


function App() {
  return (
    <ThemeProvider theme={tema}>
      <CssBaseline />
      <ToastContainer position="top-right" autoClose={4000} />
      <Routers />
    </ThemeProvider>
  );
}

export default App;
